import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FranchiseAppGlobal } from "src/app/franchise-app-global";
import { AppConfigService } from "src/app/shared/providers/config.service";
import { DonorRequestListDto, RequestAdminSearchDto } from "../models/donor-request-admin";
import { DropDownList } from "../models/common/drop-down-list";
import { AdminLookupCategory } from "../models/crType-enum";
import { PagedResult } from "../models/common/pagination";
import { FileDto } from "src/app/shared/models/models";

@Injectable({
  providedIn: "root",
})
export class DonorRequestAdminService {
  private env;
  constructor(private http: HttpClient, private config: AppConfigService) {
    this.env = config.getConfig();
  }
  getAllAdminDonorRequests(input: RequestAdminSearchDto): Observable<PagedResult<DonorRequestListDto>> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.getDonorRequestAdmin;
    return this.http.post<PagedResult<DonorRequestListDto>>(url, object);
  }
  GetRequestTypesDDL(): Observable<DropDownList<number, string>[]> {
    let url = this.env.baseUrl + FranchiseAppGlobal.getAllLookupsAdminByCategoryUrl + AdminLookupCategory.RequestType;
    return this.http.get<DropDownList<number, string>[]>(url);
  }
  GetRequestStatusDDL(): Observable<DropDownList<number, string>[]> {
    let url = this.env.baseUrl + FranchiseAppGlobal.getAllLookupsAdminByCategoryUrl + AdminLookupCategory.RequestStatus;
    return this.http.get<DropDownList<number, string>[]>(url);
  }
  ExportExcel(input: RequestAdminSearchDto): Observable<FileDto> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.donorRequestexportExcel;
    return this.http.post<FileDto>(url, object);
  }
  ExportPdf(input: RequestAdminSearchDto): Observable<FileDto> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.donorRequestexportPdf;
    return this.http.post<FileDto>(url, object);
  }
}
